<template>
    <div v-show="visible">
        <el-dialog title="设置学校" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="35%">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="学校">
                    <el-select v-model="form.schoolIds" multiple filterable collapse-tags placeholder="请选择学校" style="width:100%;">
                        <el-option
                            v-for="item in schoolOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="String(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';

export default {
    data(){
        return{
            visible: false,
            form: {
                id: '',
                schoolIds: []
            },
            schoolOptions: []
        };
    },
    methods:{
        init(data){
            this.visible = true;
            this.form.id = data.id;
            if(this.$util.isNotEmpty(data.schoolIds)){
                this.form.schoolIds = String(data.schoolIds).split(',');
            }else{
                this.form.schoolIds = [];
            }
            this.getSchoolOptions();
        },
        dialogClose(done){
            done();
            this.$reload;
        },
        getSchoolOptions(){
            let url = this.listDeptUrl;
            let data = { parentId: '0' };
            this.apiPost(url,data).then((res)=>{
                if(res.status === 200){
                    this.schoolOptions = res.data.list || [];
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            },(err)=>{
                console.log(err);
            });
        },
        save(){
            let url = this.memberProductSetSchoolUrl;
            let data = {
                id: this.form.id,
                schoolIds: this.form.schoolIds.join(',')
            };
            this.apiPost(url, data).then((res) => {
                if(res.status === 200){
                    this.$commonFn.showTip(res.message,1);
                    this.visible = false;
                    this.$parent.getData();
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            }, (err) => {
                console.log(err);
            });
        }
    },
    mixins: [http]
};
</script>



// WEBPACK FOOTER //
// src/components/page/member/product/SetSchool.vue